import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import AccountRoles from '../../account/enums/AccountRoles';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import UserList from './UserList';
import TeamList from './TeamList';
import ClubDialog from './ClubDialog';
import {useLocation, useRouteMatch} from 'react-router-dom';
import {loadClubs} from '../../account/action/accountActions';

function ClubDetail() {
    const [t] = useTranslation();
    const location = useLocation();
    const match = useRouteMatch();
    const dispatch = useDispatch();

    const [club, setClub] = useState();
    const allClubs = useSelector(state => state.account.clubs);
    const role = useSelector(state => state.account.role);

    const [showClubDialog, setShowClubDialog] = useState(false);

    useEffect(() => {
        setClub(allClubs?.find(c => c.id === match.params.id));
    }, [location, allClubs]);

    const handleSave = () => {
        setShowClubDialog(false);
        dispatch(loadClubs());
    };

    const editClub = () => {
        setShowClubDialog(true);
    };

    return (
        <>
            {
                club &&
                <>
                    <div>
                        <h1 className="d-inline">
                            {club.name}
                        </h1>
                        {
                            (role === AccountRoles.ADMINISTRATOR || role === AccountRoles.CLUB_MANAGER) &&
                            <button
                                onClick={editClub}
                                className="btn btn-transparent-primary ml4">
                                <FontAwesomeIcon icon="pencil-alt" className="mr-2"/>
                                {t('Button.EDIT')}
                            </button>
                        }
                    </div>
                    <div className="mt-5">
                        {
                            (role === AccountRoles.ADMINISTRATOR || role === AccountRoles.CLUB_MANAGER) &&
                            <UserList
                                club={club}
                            />
                        }
                    </div>
                    <div className="mt-5">
                        <TeamList
                            clubId={club.id}
                            className="mt-5"
                        />
                    </div>
                </>
            }

            <ClubDialog
                open={showClubDialog}
                club={club}
                onCancel={() => {
                    setShowClubDialog(false);
                }}
                onSave={handleSave}
            />
        </>
    );
};

export default ClubDetail;
